import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Floating "back to top" button — appears once you've scrolled down, sits above
 * the fixed Marakin footer, and smooth-scrolls to the top. Used on the long
 * legal pages (Privacy / Terms) so you can escape to the top from anywhere.
 */
export default function ScrollTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      style={{
        position: 'fixed',
        right: 16,
        bottom: 'calc(54px + var(--sab))', /* B-15 */
        zIndex: 95,
        width: 44,
        height: 44,
        borderRadius: '50%',
        background: 'var(--green)',
        color: 'var(--cream)',
        border: 'none',
        boxShadow: '0 2px 10px rgba(0,0,0,0.22)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ArrowUp size={20} />
    </button>
  );
}
